export default class TimeSelectorController {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {

	}

	$onInit() {
		this.minHour = 0;
		this.maxHour = 23;
		this.minMinute = 0;
		this.maxMinute = 59;

		this.showMessage = false;
	}

	handleInput() {
		if(this.time.hour === undefined || this.time.minute === undefined) {
			this.showMessage = true;
		}
		else {
			this.showMessage = false;
		}
	}
}
